module.exports = __webpack_public_path__ + "assets/img/sleep.005d214a.png";